var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
export default function AuthRedirect() {
    const { instance } = useMsal();
    const navigate = useNavigate();
    useEffect(() => {
        let isMounted = true;
        (() => __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield instance.handleRedirectPromise();
                try {
                    const active = (result === null || result === void 0 ? void 0 : result.account) || instance.getAllAccounts()[0];
                    if (active)
                        instance.setActiveAccount(active);
                }
                catch (_a) {
                    // ignore: best-effort
                }
            }
            catch (_b) {
                // ignore
            }
            if (!isMounted)
                return;
            const target = sessionStorage.getItem("postLoginRedirect") || "/project";
            try {
                navigate(target, { replace: true });
            }
            catch (_c) {
                try {
                    if (typeof window !== "undefined") {
                        window.location.replace(target);
                    }
                }
                catch (_d) {
                    /* noop */
                }
            }
        }))();
        return () => {
            isMounted = false;
        };
    }, [instance]);
    return React.createElement("div", null, "Signing you in\u2026");
}
